import { Directive, ElementRef, OnInit, Renderer2, inject } from '@angular/core';
import { FullScreenModeService } from '../../../core/services/full-screen-mode/full-screen-mode.service';

@Directive({ selector: '[appFullScreenMode]' })
export class FullScreenModeDirective implements OnInit {
  private fullScreenModeService = inject(FullScreenModeService);
  private elRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  ngOnInit() {
    this.fullScreenModeService.enabledAsObservable().subscribe((enabled: boolean) => {
      enabled
        ? this.renderer.setStyle(this.elRef.nativeElement, 'display', 'none')
        : this.renderer.removeStyle(this.elRef.nativeElement, 'display');
    });
  }
}
